export interface ISeason {
  year: string
  slug: string
  remoteSlug: string
  id: number
}

// First season in array is exported as the current one
const seasonsInOrder: ISeason[] = [
  { year: '2022/23', slug: 'latest', remoteSlug: '2022-23', id: 24 },
  { year: '2021/22', slug: '2021-22', remoteSlug: '2021-22', id: 23 },
]

const getRemoteSeasonSlug = (seasonSlug: string): string =>
  seasonsInOrder.find((season) => season.slug === seasonSlug).remoteSlug

module.exports = {
  seasons: seasonsInOrder,
  latestSeason: seasonsInOrder[0],
  previousSeason: seasonsInOrder[1],
  getRemoteSeasonSlug,
}
